import { z } from 'zod';

export const shiftStatusSchema = z.enum(['PENDING', 'ACTIVE', 'DONE']);
export type ShiftStatus = z.infer<typeof shiftStatusSchema>;

export const shiftSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  serviceId: z.string().uuid(),
  date: z.string(),
  startedAt: z.string().nullable(),
  endedAt: z.string().nullable(),
  overrideFixedValue: z.number().nullable(),
  status: shiftStatusSchema,
  notes: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  deletedAt: z.string().nullable(),
});
export type Shift = z.infer<typeof shiftSchema>;

export const shiftTotalsSchema = z.object({
  fixedValue: z.number(),
  itemsTotal: z.number(),
  itemsCount: z.number(),
  total: z.number(),
});
export type ShiftTotals = z.infer<typeof shiftTotalsSchema>;

export const shiftWithTotalsSchema = z.object({
  shift: shiftSchema,
  totals: shiftTotalsSchema,
});
export type ShiftWithTotals = z.infer<typeof shiftWithTotalsSchema>;

export const shiftSummaryItemSchema = z.object({
  examTypeId: z.string().uuid(),
  examTypeName: z.string(),
  shortName: z.string(),
  qty: z.number(),
  unitValue: z.number(),
  subtotal: z.number(),
});
export type ShiftSummaryItem = z.infer<typeof shiftSummaryItemSchema>;

export const shiftSummarySchema = z.object({
  shiftId: z.string().uuid(),
  status: shiftStatusSchema,
  fixedValue: z.number(),
  items: z.array(shiftSummaryItemSchema),
  total: z.number(),
});
export type ShiftSummary = z.infer<typeof shiftSummarySchema>;

export const scheduleShiftSchema = z.object({
  serviceId: z.string().uuid({ message: 'Selecione um serviço' }),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida'),
  overrideFixedValue: z
    .number({ error: 'Valor inválido' })
    .nonnegative('Valor não pode ser negativo')
    .nullable()
    .optional(),
  notes: z.string().max(5000).optional(),
});
export type ScheduleShiftInput = z.infer<typeof scheduleShiftSchema>;
